<template>
  <DialogFormWrapper>
    <template #form>
      <v-form
        id="driverBonusForm"
        ref="driverBonusForm"
        v-model="isFormValid"
        class="custom-form pt-6"
        @submit.prevent="submitBonusForm"
      >
        <v-col cols="12">
          <v-text-field
            v-model="amount"
            outlined
            label="Wartość bonusu"
            placeholder="Wpisz wartość bonusu"
            suffix="zł"
            :rules="[rules.required, rules.money, positiveAmount]"
          />
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="note"
            outlined
            :rows="3"
            auto-grow
            label="Notatka"
            placeholder="Wpisz notatkę (opcjonalnie)"
          />
        </v-col>
      </v-form>
    </template>
    <template #submit>
      <v-btn color="primary" class="base-hover" :loading="isProcessing" type="submit" form="driverBonusForm">
        {{ isEditing ? 'Zapisz bonus' : 'Dodaj bonus' }}
      </v-btn>
    </template>
  </DialogFormWrapper>
</template>

<script>
import DialogFormWrapper from './Partials/DialogFormWrapper'
import rules from '../../utils/validators'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    DialogFormWrapper
  },
  props: {
    driverId: {
      type: Number,
      required: true
    },
    month: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      rules,
      amount: null,
      note: null,
      isFormValid: true
    }
  },
  computed: {
    ...mapState({
      day: state => state.layout.dialog.item,
      isProcessing: state => state.driversDetails.isProcessing
    }),
    isEditing() {
      return !!this.day?.bonus
    }
  },
  created() {
    const { bonus } = this.day || {}
    if (bonus) {
      // Backend keeps amounts in grosze
      this.amount = String(bonus.amount / 100).replace('.', ',')
      this.note = bonus.note
    }
  },
  methods: {
    ...mapActions({
      createBonus: 'driversDetails/createBonus',
      updateBonus: 'driversDetails/updateBonus',
      closeDialog: 'layout/closeDialog'
    }),
    positiveAmount(value) {
      return Number(String(value).replace(',', '.')) > 0 || 'Wartość musi być większa od 0'
    },
    submitBonusForm() {
      this.$refs.driverBonusForm.validate()
      if (!this.isFormValid) return

      const params = {
        driverId: this.driverId,
        month: this.month,
        amount: this.amount,
        note: this.note || null
      }
      const request = this.isEditing
        ? this.updateBonus({ ...params, id: this.day.bonus.id })
        : this.createBonus({ ...params, date: this.day.date })

      request.then(() => {
        this.closeDialog()
      })
    }
  }
}
</script>
